module.exports = __webpack_public_path__ + "media/v2/components/shared/InstagramCarousel/mockPicts/23-0cd061eb4ad534367cd8ac344d7d0256.png";